import { render, staticRenderFns } from "./CoinBody.vue?vue&type=template&id=a1fb2304&scoped=true&"
import script from "./CoinBody.vue?vue&type=script&lang=ts&"
export * from "./CoinBody.vue?vue&type=script&lang=ts&"
import style0 from "./CoinBody.vue?vue&type=style&index=0&id=a1fb2304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fb2304",
  null
  
)

export default component.exports